import { maxWorkingHoursUi, minJobHoursValue, tipTaxAmount } from './jobs';

export const labels = {
  pay_rate: 'Pay Rate',
  cost_rate: 'Billing Rate',
  needApproveLabel: 'Please Approve Hours',
  lta: 'LTA',
  event: 'EVENT',
  groupMessages: 'Group Messages',
  directMessages: 'Direct Messages'
};

export const confirmationMessages = {
  removeWorker: 'Are you sure you want to remove this worker from the job?',
  hireWorker: 'Hire this worker for the job?',
  workerNotShow: 'You are marking this worker as not showing up for the job?',
  workerCancelled: 'You are marking this worker as they cancelled the job?',
  workerCancelledConsequence: 'You are marking this worker they cancelled the job inside of 24hrs with consequences?',
  cancelJobWithin24Hours: {
    admin: 'You are cancelling a job within 24 hours of its start time.\n\nThe customer will be invoiced 50% of the start time if there are any hired workers for this job. Would you like to proceed?',
    employer: 'You are cancelling a job within 24 hours of its start time.\n\nYou will be invoiced 50% of the start time if there are any hired workers for this job. Would you like to proceed?'
  },
  cancelJob: 'Are you sure you want to cancel this job?',
  postJob: 'Are you sure you want to post this job?',
  exitJobCreation: 'Are you sure you want to cancel? Your job will not be saved.',
  saveDraftWithWorkers: 'Please note that workers you selected will not be retained when the job is saved as draft.',
  approveJob: 'Are you sure you want to approve the job? You would not be able to edit anything after this.',
  unApproveJob: 'Are you sure you want to unapprove this job?',
  taxOnTips: `We add a ${tipTaxAmount}% surcharge on any tips to cover additional payroll taxes`
};

export const alertMessages = {
  jobIsFilled: 'This job is already filled.',
  notAvailableLtaWorker: 'This worker is no longer available for LTA',
  noCConFile: {
    admin: 'You Can\'t Post this Job. No Credit Card on File.',
    employer: 'You Can\'t Post this Job. No Credit Card on File. Please contact support@gravy.work to add a credit card on file.'
  },
  noCConFileJobCreation: {
    admin: 'You Can\'t Post this Job. No Credit Card on File. Job was saved as draft.',
    employer: 'You Can\'t Post this Job. No Credit Card on File. Job was saved as draft. Please contact support@gravy.work to add a credit card on file.'
  },
  noCConFilePayment: {
    admin: 'Credit card is not required. You can change it on details tab.',
    employer: 'Sent via email. If you would like to set up payments with a credit card please contact Gravy Support.'
  },
  jobTimelineError: 'There is a problem with the time entered. Please reenter start and end time.',
  invalidAddress: 'Sorry, the address is invalid.',
  approveJobNoHours: 'Actual hours must be entered for all workers before approving. Edit the worker to enter the hours.',
  costPayRateIssue: `Sorry, there is issue with calculating ${labels.pay_rate} and ${labels.cost_rate} for these job address and skill`
};

export const errorRequiredText = 'Required';
export const errorNotValidText = 'Not valid';
export const errorNotValidPhone = 'Not valid. Use 000-000-0000 format';
export const passwordInfoMessage = 'The password must be at least 8 characters with 1 Uppercase and 1 Number';

/**
 * @description Error message on job creation
 * @type {string}
 */
export const errorMinJobHoursMessage = `Job duration should be at least ${minJobHoursValue} hours`;

/**
 * @description Error message for worker hours entering modal
 * @type {string}
 */
export const errorMinWorkerHoursMessage = `Job working hours should be at least ${minJobHoursValue} hours`;

/**
 * @description Error message for worker hours entering modal
 * @type {string}
 */
export const errorMaxJobHoursMessage = `Max job duration is ${maxWorkingHoursUi}`;

export const otherSentHomeReason = 'Worker was sent home';

export default {
  warning: {
    noCustomRateFound: 'Please contact your Gravy’s sales representative to confirm the rate for this position'
  }
};

export const workerBusyMessage = 'Worker may not be available due to working another Gravy job that day';



// WEBPACK FOOTER //
// ./src/constants/text.js